import {
    AllEvents,
    ArticleLikePublication,
    isArticle,
} from '@news-mono/web-common'
import React from 'react'
import { LazyGeneralInArticleBanner } from '../../../banners/GenericInArticleBanner'
import {
    InlineContentTypes,
    InlineCourtInTheActBanner,
} from '../SharedPublication.routing'

export interface getInlinePositionedGeneralBannerProps {
    publication: ArticleLikePublication
    inlinePublicationContent: InlineContentTypes[]
    onEvent: (event: AllEvents) => void
}

export function isInlineCourtInTheActBanner(
    content: InlineContentTypes,
): content is InlineCourtInTheActBanner {
    return content.kind === 'inline-court-in-the-act-banner'
}

export function getInlinedPositionedCourtInTheActBanner({
    publication,
    inlinePublicationContent,
    onEvent,
}: getInlinePositionedGeneralBannerProps) {
    if (!isArticle(publication)) {
        return []
    }

    const validTopics = [
        'news/crime',
        'news/court-justice',
    ]

    if (
        !validTopics.includes(publication.primaryTopic.id) &&
        !publication.secondaryTopics.find((topic) =>
            validTopics.includes(topic.id),
        )
    ) {
        return []
    }

    return inlinePublicationContent
        .filter(isInlineCourtInTheActBanner)
        .map((content: InlineCourtInTheActBanner) => {
            return {
                position: content.insertAfter,
                element: (
                    <LazyGeneralInArticleBanner
                        onEvent={onEvent}
                        {...content.props}
                    />
                ),
            }
        })
}
